import React from "react";

const Jumbotron = () => {
  return (
    <div className="jumbotron homepage bg-gray-100 py-16 min-h-[300px] relative">
      <div className="container mx-auto px-4 relative">
        {/* Breadcrumbs */}
        <div className="breadcrumbs text-sm text-gray-500 mb-6 flex items-center space-x-1">
          <span>
            <a
              href="/"
              className="home"
              title="PrepNexa"
              aria-label="Home"
              data-wpel-link="internal"
            >
              <span className="sr-only">Home</span>
              <span className="hover:underline text-base font-medium">
                Home
              </span>
            </a>
          </span>
          <span>/</span>
          <span>
            <span
              className="breadcrumb_last text-base font-semibold text-gray-700"
              aria-current="page"
            >
              Blog
            </span>
          </span>
        </div>

        {/* Jumbo Row */}
        <div className="jumbo-row flex flex-wrap items-center relative">
          {/* Left Section */}
          <div className="jumbotron-left w-full md:w-2/3">
            <h1 className="text-[40px] md:text-[48px] font-bold text-gray-800 leading-tight">
              PrepNexa blog
            </h1>
            <p className="mt-4 text-[18px] text-gray-600 leading-relaxed">
              PrepNexa is committed to your PTE success and excellence. Stay
              tuned for updates, expert advice, and the latest resources to
              elevate your PTE preparation journey.
            </p>
          </div>

          {/* Right Section with background image */}
          <div
            className="jumbotron-right hidden md:block absolute bottom-0 right-0 w-full md:w-1/2"
            style={{
              backgroundImage:
                "url(//s22908.pcdn.co/wp-content/themes/newspaper-child/css/../images/Streaming-wider.png)",
              backgroundPosition: "center", // Center the image
              backgroundSize: "contain", // Ensure the entire image is visible
              backgroundRepeat: "no-repeat", // Prevent image repetition
              height: "200%", // Ensure it takes full height of the container
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Jumbotron;
